import React, {useContext} from 'react';
import {injectIntl} from "react-intl";
import FormContext from "formContext";

function StackableCheckboxes({intl, settings, ...rest}) {
  const {currentStep, setFormData} = useContext(FormContext);
  const {checkboxes, title, state, errors, hidden = false, required = true, divClasses = ''} = settings || {};

  const renderTitle = () => {
    if (!title) {
      return null;
    }

    return (
      <legend className="form-group__label">{intl.formatMessage({id: title})}</legend>
    )
  };

  if (hidden) {
    return '';
  }

  const handleChange = e => {
    const {name, checked} = e.target;
    setFormData(prev => {
      if (!prev[currentStep]) {
        prev[currentStep] = {};
      }
      prev[currentStep][name] = checked;
      return {
        ...prev
      }
    });
  }

  const renderCheckboxes = () => {
    const renderable = [];
    checkboxes.forEach((checkbox, id) => {
      const {name, label} = checkbox;

      const hasErrors = (errors && ((errors.hasOwnProperty(name) && errors[name].length) || (required && errors.hasOwnProperty('generalError'))));

      let checked = false;
      if (state && state.hasOwnProperty(name)) {
        checked = state[name];
      }

      renderable.push(
        <div className={`form-group__input ${hasErrors ? 'form-group--error' : ''} ${divClasses}`} key={`checkboxes-${name}-${id}`}>
          <label htmlFor={`checkbox-${name}`} className="selection-control selection-control--checkbox">
            <span className="selection-control__input">
              <input
                id={`checkbox-${name}`}
                name={name}
                type="checkbox"
                value={true}
                checked={(checked)}
                {...rest}
                onChange={handleChange}
              />
              <span className="icon selection-control__control" aria-hidden="true">
                <svg viewBox="0 0 16 16">
                  <polyline points="2.1,8.5 6.2,12.4 13.9,5.1"/>
                </svg>
              </span>
            </span>
            <span className="selection-control__label">
              {intl.formatMessage({id: label})}
            </span>
          </label>
          {hasErrors && errors.hasOwnProperty(name) && errors[name].length && (
            <div key={`errorField-${name}`} className="form-group__feedback">{errors[name]}</div>
          )}
        </div>
      );
    })

    return renderable;
  };

  return (
    <fieldset className={`form-group form-group--selection-control`}>
      {renderTitle()}
      {renderCheckboxes()}
    </fieldset>
  );

}

export default injectIntl(StackableCheckboxes);
